
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => Array.isArray(list) && list.length > 0

  const {
    exceptions = [],
    costCentres = [],
    vehicleDescriptions = [],
    drivers = [],
    statuses = [],
    fleets = [],
    fleetControllers = [],
  } = filters || {}

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>

      <Divider />

      <Stack gap={2} py={2}>
        {hasList(exceptions) && (
          <MuiFormSelect
            id="exception"
            label="Exception Type"
            options={exceptions}
            value={filtered.exception}
            onChange={onSelect('exception')}
            includeEmptyOption />
        )}

        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            includeEmptyOption
            emptyOptionLabel="All cost centres"
            onChange={onSelect('costCentre')} />
        )}

        {hasList(vehicleDescriptions) && (
          <MuiFormSelect
            id="vehicleDescription"
            label="Vehicle Type"
            options={vehicleDescriptions}
            value={filtered.vehicleDescription}
            onChange={onSelect('vehicleDescription')}
            includeEmptyOption />
        )}

        {hasList(drivers) && (
          <MuiFormSelect
            id="driver"
            label="Driver"
            options={drivers}
            value={filtered.driver}
            onChange={onSelect('driver')}
            includeEmptyOption />
        )}

        {hasList(statuses) && (
          <MuiFormSelect
            id="status"
            label="Status"
            options={statuses}
            value={filtered.status}
            onChange={onSelect('status')}
            includeEmptyOption />
        )}

        {hasList(fleets) && (
          <MuiFormSelect
            id="fleet"
            label="Fleet"
            options={fleets}
            value={filtered.fleet}
            onChange={onSelect('fleet')}
            includeEmptyOption />
        )}

        {hasList(fleetControllers) && (
          <MuiFormSelect
            id="fleetController"
            label="Fleet Controller"
            options={fleetControllers}
            value={filtered.fleetController}
            onChange={onSelect('fleetController')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
